



















































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import {
  DxDataGrid,
  DxSelection,
  DxPaging,
  DxFilterRow,
  DxScrolling,
  DxSearchPanel,
} from "devextreme-vue/data-grid";
import { centros } from "@/shared/dtos/centros";
import centrosModule from "@/store/modules/centros-module";

declare global {
  interface Window {
    google: any;
  }
}

interface GoogleMapMarker {
  position: {
    lat: number;
    lng: number;
  };
  info: any;
  nombre: string;
  id: number;
  colorRuta?: string;
  type?: "start" | "end" | "center";
}

interface PuntoRuta {
  nombre: string;
  direccion?: string;
  posicion: string;
  type: "start" | "center" | "end";
  distanciaAlSiguiente?: number;
  tiempoAlSiguiente?: number;
  lat: number;
  lng: number;
  id_centro: number;
  siguiente?: PuntoRuta; // Nuevo campo para el siguiente centro
  colorRuta?: string; // Color de la ruta
}

interface DayPlan {
  day: string;
  centers: PuntoRuta[];
  expanded: boolean;
  travelTimeToFirstCenter?: number;
  distanciaAlPrimerCentro?: number;
  tiempoTotalDia?: number; // tiempo total del día en minutos
  hotel?: {
    name: string;
    address: string;
    price: number;
    mapUrl: string;
  };
}

interface Hotel {
  name: string;
  address: string;
  price: number;
  mapUrl: string;
}

@Component({
  components: {
    DxDropDownBox,
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxScrolling,
    DxSearchPanel,
  },
})
export default class PlanificadorRutasCompleto extends Vue {
  // Configuración del mapa
  public center = { lat: 39.399548026808425, lng: -0.4157916279543559 };
  public zoom = 6.5;
  public valid = false;
  public loading = false;

  // Configuración de ruta
  public startLocation: { lat: number; lng: number } | null = null;
  public endLocation: { lat: number; lng: number } | null = null;
  public startLocationName = "";
  public endLocationName = "";
  public customMarkers: GoogleMapMarker[] = [];
  public selectedCentros: number[] = [];
  public selectedCentros_DropDown: any[] = [];
  public usar_ruta_optimizada = false;
  public maxHorasPorDia: number = 8; // máximo de horas al día
  public tiempoLimpiezaCentro: number = 2.5; // en horas (media hora por defecto)
  public MAX_WAYPOINTS = 23; // Google Maps API permite un máximo de 23 waypoints por ruta
  public diasMaximosFuera: number = 5; // días máximos fuera de la ruta

  // Configuración de días
  public weekDays = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo",
  ];
  public workingDays: string[] = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
  ];

  public rutaColors: string[] = [
    "#1e88e5", // Azul
    "#43a047", // Verde
    "#ff9900", // Naranja
    "#8e24aa", // Violeta
    "#fb8c00", // Ámbar
    "#3949ab", // Azul intenso
    "#d81b60", // Rosa fuerte
  ];

  public maxCentersPerDay = 3;
  public maxSelectedCenters = 30;

  // Configuración de vehículo
  public consumoGasolina = 7;
  public precioGasolina = 1.5;

  // Resultados
  public rutaCalculada = false;
  //public routePlan: DayPlan[] = [];

  public routePlans: DayPlan[][] = [];

  // Ventana de información
  public infoWindowOpened = false;
  public infoWindowOptions = { pixelOffset: { width: 0, height: -30 } };
  public infoWindowPosition: { lat: number; lng: number } | null = null;
  public infoWindowContent: { nombre?: string } = {};

  // Notificaciones
  public snackbar = {
    show: false,
    text: "",
    color: "success",
  };

  // Reglas de validación
  public requiredRules = [(v: string) => !!v || "Este campo es obligatorio"];
  public positiveNumberRules = [(v: number) => v > 0 || "Debe ser positivo"];
  public workingDaysRules = [
    (v: string[]) => v.length > 0 || "Seleccione al menos un día",
  ];

  async created() {
    await centrosModule.getcentroses();
  }

  // Propiedades computadas
  get centrosOptions() {
    return centrosModule.centroses;
  }

  get filteredCentrosOptions() {
    return this.centrosOptions.filter(
      (center) =>
        !this.selectedCentros.includes(center.id) ||
        this.selectedCentros_DropDown.some(
          (selected: any) => selected.id === center.id
        )
    );
  }

  get markers(): GoogleMapMarker[] {
    return this.centrosOptions.map((x: centros) => ({
      position: {
        lat: Number.parseFloat(x.latitud.replace(",", ".")),
        lng: Number.parseFloat(x.longitud.replace(",", ".")),
      },
      info: x.toJson(),
      nombre: x.nombre,
      id: x.id,
      type: "center",
    }));
  }

  /*get filteredMarkers(): GoogleMapMarker[] {
    let result: GoogleMapMarker[] = this.markers.filter((marker) =>
      this.selectedCentros.includes(marker.id)
    );
    return [...result, ...this.customMarkers];
  }*/
  get filteredMarkers(): GoogleMapMarker[] {
    const marcadores: GoogleMapMarker[] = [];

    for (const plan of this.routePlans) {
      for (const day of plan) {
        for (const punto of day.centers) {
          // Buscar el marcador original asociado
          const baseMarker = this.markers.find((m) => m.id === punto.id_centro);
          if (baseMarker) {
            marcadores.push({
              ...baseMarker,
              type: punto.type,
              colorRuta: punto.colorRuta,
            });
          }
        }
      }
    }

    // Incluir también los personalizados (inicio y fin)
    return [...marcadores, ...this.customMarkers];
  }

  get costoGasolina() {
    return (
      (this.distanciaTotal / 1000) *
      (this.consumoGasolina / 100) *
      this.precioGasolina
    );
  }
  get distanciaTotal(): number {
    return this.routePlans
      .flatMap((route) => route) // Flatten cada routePlan
      .flatMap((day) => day.centers)
      .reduce((total, center) => total + (center.distanciaAlSiguiente || 0), 0);
  }

  get tiempoTotal(): number {
    return this.routePlans
      .flatMap((route) => route)
      .flatMap((day) => day.centers)
      .reduce((total, center) => total + (center.tiempoAlSiguiente || 0), 0);
  }

  get tiempoLimpiezaTotal(): number {
    const totalCentros = this.routePlans
      .flatMap((route) => route)
      .flatMap((day) => day.centers).length;
    return totalCentros * this.tiempoLimpiezaCentro * 3600; // en segundos
  }

  get tiempoTotalCombinado(): number {
    return this.tiempoTotal + this.tiempoLimpiezaTotal;
  }

  getResumenRuta(routePlan: DayPlan[]) {
    // Tiempo de limpieza (solo centros)
    const limpieza =
      routePlan.flatMap((d) => d.centers.filter((c) => c.type === "center"))
        .length *
      this.tiempoLimpiezaCentro *
      3600;

    // Tiempo de conducción incluyendo tiempo hasta el primer centro
    const conduccion = routePlan.reduce((total, d) => {
      const internos = d.centers.reduce(
        (sum, c) => sum + (c.tiempoAlSiguiente || 0),
        0
      );
      const alPrimero = d.travelTimeToFirstCenter || 0;
      return total + internos + alPrimero;
    }, 0);

    // Distancia total incluyendo el trayecto al primer centro
    const distancia = routePlan.reduce((total, d) => {
      const internos = d.centers.reduce(
        (sum, c) => sum + (c.distanciaAlSiguiente || 0),
        0
      );
      const alPrimero = d.distanciaAlPrimerCentro || 0;
      return total + internos + alPrimero;
    }, 0);

    // Cálculo de coste gasolina
    const gasolina =
      (distancia / 1000) * (this.consumoGasolina / 100) * this.precioGasolina;

    return {
      limpieza,
      conduccion,
      total: limpieza + conduccion,
      distancia,
      gasolina,
    };
  }

  // Métodos
  setStartLocation(place: any) {
    if (!place || !place.geometry) return;
    this.startLocation = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    this.startLocationName = place.name || place.formatted_address;
    this.updateCustomMarker(
      "start",
      this.startLocation,
      this.startLocationName
    );
    this.center = this.startLocation;
    this.zoom = 12;
  }

  setEndLocation(place: any) {
    if (!place || !place.geometry) return;
    this.endLocation = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    this.endLocationName = place.name || place.formatted_address;
    this.updateCustomMarker("end", this.endLocation, this.endLocationName);
  }

  updateCustomMarker(
    type: "start" | "end",
    position: { lat: number; lng: number },
    nombre: string
  ) {
    this.customMarkers = this.customMarkers.filter((m) => m.type !== type);
    this.customMarkers.push({
      position,
      info: {},
      nombre,
      id: type === "start" ? -1 : -2,
      type,
    });
  }

  getTiempoTotalVisual(day: DayPlan): { horas: number; minutos: number } {
    //travelTimeToFirstCenter
    const totalMinutos = day.tiempoTotalDia || 0;
    const tiempoprimercentro = (day.travelTimeToFirstCenter || 0) / 60; // Convertir a minutos
    // Sumamos a los minutos totales
    const totalMinutosConPrimero = totalMinutos + tiempoprimercentro;

    const horas = Math.floor(totalMinutosConPrimero / 60);
    const minutos = Math.round(totalMinutosConPrimero % 60);

    return { horas, minutos };
  }

  updateSelectedCentros(e: any) {
    this.selectedCentros = e.value || [];
  }

  selectionChanged(e: any) {
    this.selectedCentros_DropDown = e.selectedRowKeys;
    this.selectedCentros = e.selectedRowKeys.map((item: any) => item.id);
  }

  getDisplayText() {
    if (!this.selectedCentros.length) return "Seleccione centros";
    const selected = this.centrosOptions.filter((c) =>
      this.selectedCentros.includes(c.id)
    );
    return selected.map((c) => c.nombre).join(", ");
  }

  formatDistance(metros: number = 0): string {
    return metros < 1000 ? `${metros} m` : `${(metros / 1000).toFixed(1)} km`;
  }

  formatTime(segundos: number = 0): string {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    return horas > 0 ? `${horas}h ${minutos}min` : `${minutos} min`;
  }

  /*customMarker(type?: "start" | "end" | "center") {
    const icons = {
      start: {
        url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
        scaledSize: { width: 50, height: 50 },
      },
      end: {
        url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
        scaledSize: { width: 50, height: 50 },
      },
      center: {
        url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        scaledSize: { width: 50, height: 50 },
      },
    };
    return icons[type || "center"];
  }*/
  customMarker(type?: "start" | "end" | "center", color?: string) {
    let finalColor = color || "#4285F4"; // Default para centros

    // Forzar color por tipo
    if (type === "start") {
      finalColor = "#43a047"; // Verde
    } else if (type === "end") {
      finalColor = "#d81b60"; // Rojo
    }
    return {
      url: `http://maps.google.com/mapfiles/ms/icons/${this.hexToGoogleColor(
        finalColor
      )}-dot.png`,
      scaledSize: { width: 50, height: 50 },
    };
  }

  hexToGoogleColor(hex: string): string {
    const mapa = {
      "#1e88e5": "blue",
      "#43a047": "green",
      "#ff9900": "orange",
      "#8e24aa": "purple",
      "#fb8c00": "yellow",
      "#3949ab": "blue",
      "#d81b60": "pink",
    };
    return mapa[hex.toLowerCase() as keyof typeof mapa] || "red";
  }

  openInfoWindow(index: number) {
    const marker = this.filteredMarkers[index];
    if (marker) {
      this.infoWindowPosition = marker.position;
      this.infoWindowContent = { nombre: marker.nombre };
      this.infoWindowOpened = true;
    }
  }

  closeInfoWindow() {
    this.infoWindowOpened = false;
  }

  toggleDayExpansion(planIndex: number, dayIndex: number) {
    const plan = this.routePlans[planIndex];
    if (plan && plan[dayIndex]) {
      plan[dayIndex].expanded = !plan[dayIndex].expanded;
    } else {
      console.warn("Índice de ruta o día inválido:", planIndex, dayIndex);
    }
  }

  async calcularRuta() {
    try {
      this.loading = true;
      this.rutaCalculada = false;
      this.routePlans = []; // Reiniciar las rutas planificadas

      // Validaciones básicas
      if (!this.startLocation) throw new Error("Seleccione un punto de inicio");
      if (!this.endLocation) throw new Error("Seleccione un punto final");
      if (!this.workingDays.length)
        throw new Error("Seleccione días laborables");
      if (!this.selectedCentros.length)
        throw new Error("Seleccione al menos un centro");
      var centrosLimpiados: PuntoRuta[] = [];

      while (true) {
        var routePlan: DayPlan[] = [];
        // Filtrar los centros seleccionados que aún no han sido limpiados
        const selectedMarkers = this.markers.filter(
          (marker) =>
            this.selectedCentros.includes(marker.id) &&
            !centrosLimpiados.some((c) => c.id_centro === marker.id)
        );

        if (selectedMarkers.length === 0) break; // Todos han sido procesados

        // Ordenar los centros restantes

        const selectedCenters = await this.getOrderedCenters(selectedMarkers);

        for (let i = 0; i < selectedCenters.length; i++) {
          const m = selectedCenters[i];
          // Obtener la dirección del centro
          selectedCenters[i].direccion = await this.geocodePosition(
            m.lat,
            m.lng
          );
        }

        // Dividir los centros por días
        routePlan = this.splitCentersByDay(selectedCenters);
        //Cogemos como maximo dias Maximos Fuera
        routePlan = routePlan.slice(0, this.diasMaximosFuera);
        //Nos guardamos los centros para no volver a seleccionarlos
        for (let i = 0; i < routePlan.length; i++) {
          for (let j = 0; j < routePlan[i].centers.length; j++) {
            centrosLimpiados.push(routePlan[i].centers[j]);
          }
        }

        // Añadir punto "Fin" como último centro del último día
        const ultimoDia = routePlan[routePlan.length - 1];
        const puntoFin: PuntoRuta = {
          nombre: this.endLocationName || "Fin de jornada",
          direccion: "",
          posicion: `${this.endLocation!.lat}, ${this.endLocation!.lng}`,
          type: "end",
          lat: this.endLocation!.lat,
          lng: this.endLocation!.lng,
          id_centro: -999,
          distanciaAlSiguiente: 0,
          tiempoAlSiguiente: 0,
        };
        if (ultimoDia.centers.length > 0) {
          const ultimoCentro = ultimoDia.centers[ultimoDia.centers.length - 1];
          ultimoCentro.siguiente = puntoFin;
        }

        ultimoDia.centers.push(puntoFin);

        if (
          this.startLocation &&
          routePlan.length > 0 &&
          routePlan[0].centers.length > 0
        ) {
          const origin = new window.google.maps.LatLng(
            this.startLocation.lat,
            this.startLocation.lng
          );
          const destino = new window.google.maps.LatLng(
            routePlan[0].centers[0].lat,
            routePlan[0].centers[0].lng
          );
          const directionsService = new window.google.maps.DirectionsService();
          const result = await this.getRouteData(
            directionsService,
            origin,
            destino
          );
          if (result) {
            routePlan[0].travelTimeToFirstCenter = result.duration.value;
            routePlan[0].distanciaAlPrimerCentro = result.distance.value;
          }
        }

        // Calcular rutas para cada día y obtener hoteles
        routePlan = await this.calculateDayRoutes(routePlan);
        // Guardar esta ruta en el array general
        // this.routePlans.push(routePlan.map((day) => ({ ...day })));
        const colorRuta =
          this.rutaColors[this.routePlans.length % this.rutaColors.length];

        // Asignar color a cada centro del bloque
        for (const day of routePlan) {
          for (const centro of day.centers) {
            centro.colorRuta = colorRuta;
          }
        }

        // Y luego ya se puede hacer el push
        this.routePlans.push(routePlan.map((day) => ({ ...day })));

        // Limpiar la ruta actual antes de la siguiente iteración
        routePlan = [];
      }

      this.rutaCalculada = true;
      this.snackbar = {
        show: true,
        text: "Ruta calculada correctamente",
        color: "success",
      };
    } catch (error) {
      console.error("Error al calcular ruta:", error);
      //@ts-ignore
      this.snackbar = { show: true, text: error.message, color: "error" };
    } finally {
      this.loading = false;
    }
  }

  async getOrderedCenters(
    selectedMarkers: GoogleMapMarker[]
  ): Promise<PuntoRuta[]> {
    if (selectedMarkers.length === 0) return [];

    if (selectedMarkers.length === 1) {
      const unico = selectedMarkers[0];
      return [
        {
          nombre: unico.nombre,
          direccion:
            unico.info && unico.info.direccion ? unico.info.direccion : "",
          posicion: unico.position.lat + ", " + unico.position.lng,
          type: "center",
          lat: unico.position.lat,
          lng: unico.position.lng,
          id_centro: unico.id,
        },
      ];
    }

    const chunkSize = 23; // máximo de waypoints permitidos
    const chunks: GoogleMapMarker[][] = [];

    // Dividir en tramos
    for (let i = 0; i < selectedMarkers.length; i += chunkSize) {
      chunks.push(selectedMarkers.slice(i, i + chunkSize));
    }

    const orderedTotal: PuntoRuta[] = [];

    let origin: { lat: number; lng: number } = { lat: 0, lng: 0 };

    const destination =
      this.endLocation || selectedMarkers[selectedMarkers.length - 1].position;

    // Lógica del checkbox
    if (this.usar_ruta_optimizada) {
      // Buscar el centro más alejado del destino como origen
      let maxDist = 0;
      for (let i = 0; i < selectedMarkers.length; i++) {
        const m = selectedMarkers[i];
        const dLat = m.position.lat - destination.lat;
        const dLng = m.position.lng - destination.lng;
        const dist = Math.sqrt(dLat * dLat + dLng * dLng);
        if (dist > maxDist) {
          maxDist = dist;
          origin = m.position;
        }
      }
    } else {
      origin = this.startLocation || selectedMarkers[0].position;
    }

    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i];
      const isLast = i === chunks.length - 1;

      // Definir el destino de este tramo
      const tramoDestino = isLast
        ? destination
        : chunk[chunk.length - 1].position;

      // Preparar waypoints del tramo actual
      const waypoints = chunk
        .filter(
          (m) =>
            (m.position.lat !== origin.lat || m.position.lng !== origin.lng) &&
            (m.position.lat !== tramoDestino.lat ||
              m.position.lng !== tramoDestino.lng)
        )
        .map((marker) => ({
          location: marker.position,
          stopover: true,
        }));

      // Solicitar ruta para este tramo
      const orderedChunk = await this.solicitarRutaGoogle(
        origin,
        tramoDestino,
        waypoints,
        selectedMarkers
      );
      orderedTotal.push(...orderedChunk);

      // Actualizar el origen del próximo tramo
      origin = tramoDestino;
    }

    return orderedTotal;
  }

  private async solicitarRutaGoogle(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    waypoints: google.maps.DirectionsWaypoint[],
    allMarkers: GoogleMapMarker[]
  ): Promise<PuntoRuta[]> {
    const directionsService = new window.google.maps.DirectionsService();

    const result = await new Promise<google.maps.DirectionsResult>(
      (resolve, reject) => {
        directionsService.route(
          {
            origin,
            destination,
            waypoints,
            travelMode: window.google.maps.TravelMode.DRIVING,
            optimizeWaypoints: true,
          },
          (
            response: google.maps.DirectionsResult,
            status: google.maps.DirectionsStatus
          ) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
              resolve(response);
            } else {
              reject("Error al calcular subruta: " + status);
            }
          }
        );
      }
    );

    const ordenados: PuntoRuta[] = [];

    const waypointOrder = result.routes[0].waypoint_order;
    const allLocations = [
      origin,
      ...waypoints.map((w) => w.location as google.maps.LatLngLiteral),
      destination,
    ];

    // Reordenar ubicaciones usando el orden optimizado
    const fullOrder = [
      0,
      ...waypointOrder.map((i) => i + 1),
      allLocations.length - 1,
    ];

    for (let i = 0; i < fullOrder.length; i++) {
      const loc = allLocations[fullOrder[i]];
      const marker = allMarkers.find(
        (m) => m.position.lat === loc.lat && m.position.lng === loc.lng
      );
      if (marker) {
        ordenados.push({
          nombre: marker.nombre,
          direccion:
            marker.info && marker.info.direccion ? marker.info.direccion : "",
          posicion: `${marker.position.lat}, ${marker.position.lng}`,
          type: "center",
          lat: marker.position.lat,
          lng: marker.position.lng,
          id_centro: marker.id,
        });
      }
    }

    // Añadir distancias y tiempos
    const legs = result.routes[0].legs;
    for (let i = 0; i < legs.length; i++) {
      if (ordenados[i]) {
        const leg = legs[i];
        ordenados[i].distanciaAlSiguiente = leg.distance
          ? leg.distance.value
          : 0;
        ordenados[i].tiempoAlSiguiente = leg.duration ? leg.duration.value : 0;
        ordenados[i].siguiente = ordenados[i + 1] || null; // Asignar el siguiente centro
      }
    }

    return ordenados;
  }

  splitCentersByDay(centers: PuntoRuta[]): DayPlan[] {
    const dayPlans: DayPlan[] = [];
    const maxHoras = this.maxHorasPorDia;
    const tiempoLimpieza = this.tiempoLimpiezaCentro;

    let currentDay: DayPlan = {
      day: `Día 1 (${this.workingDays[0] || "Lunes"})`,
      centers: [],
      expanded: true,
    };

    let currentHours = 0;
    let dayIndex = 0;

    for (let i = 0; i < centers.length; i++) {
      const center = centers[i];

      // Tiempo de limpieza (en horas)
      const limpiezaHoras = tiempoLimpieza;

      // Tiempo de conducción al siguiente punto (en horas)
      const tiempoConduccionSegundos = center.tiempoAlSiguiente || 0;
      const tiempoConduccionHoras = tiempoConduccionSegundos / 3600;

      // Tiempo estimado total del centro
      const tiempoTotalCentro = limpiezaHoras + tiempoConduccionHoras;

      // ¿Nos pasamos del máximo? Crea un nuevo día
      if (
        currentHours + tiempoTotalCentro > maxHoras &&
        currentDay.centers.length > 0
      ) {
        currentDay.tiempoTotalDia = Math.round(currentHours * 60); // minutos
        dayPlans.push(currentDay);
        dayIndex++;
        const nombreDia =
          this.workingDays[dayIndex % this.workingDays.length] ||
          `Día ${dayIndex + 1}`;
        currentDay = {
          day: `Día ${dayIndex + 1} (${nombreDia})`,
          tiempoTotalDia: Math.round(currentHours * 60), // en minutos
          centers: [],
          expanded: false,
        };
        currentHours = 0;
      }

      currentDay.centers.push(center);
      currentHours += tiempoTotalCentro;
    }

    // Agregar el último día si quedó algo
    if (currentDay.centers.length > 0) {
      currentDay.tiempoTotalDia = Math.round(currentHours * 60); // minutos

      dayPlans.push(currentDay);
    }

    /* for (let i = 0; i < dayPlans.length; i++) {
      const dia = dayPlans[i];
      const tiempoExistente =
        dayPlans[i].tiempoTotalDia != null ? dayPlans[i].tiempoTotalDia : 0;
      const tiempoNuevo =
        dia.travelTimeToFirstCenter != null ? dia.travelTimeToFirstCenter : 0;
      dayPlans[i].tiempoTotalDia =
        (tiempoExistente || 0) + Math.round(tiempoNuevo * 60);
    }*/

    return dayPlans;
  }

  async calculateDayRoutes(routePlan: DayPlan[]) {
    if (!window.google || !window.google.maps) {
      throw new Error("Google Maps API no disponible");
    }

    const directionsService = new window.google.maps.DirectionsService();
    const mapRef = this.$refs.map as Vue & { $mapObject: any };
    if (!mapRef || !mapRef.$mapObject) return routePlan;

    // Resetear totales

    for (let i = 0; i < routePlan.length; i++) {
      const dayPlan = routePlan[i];
      const centers = dayPlan.centers;

      // Calcular ruta para el día
      if (centers.length > 0) {
        // Calcular tiempo al primer centro (solo para el primer día)
        if (i === 0 && this.startLocation) {
          const origin = new window.google.maps.LatLng(
            this.startLocation.lat,
            this.startLocation.lng
          );
          const destination = new window.google.maps.LatLng(
            centers[0].lat,
            centers[0].lng
          );

          const result = await this.getRouteData(
            directionsService,
            origin,
            destination
          );
          if (result) {
            dayPlan.travelTimeToFirstCenter = result.duration.value;
            dayPlan.distanciaAlPrimerCentro = result.distance.value;
          }
        }

        // Calcular rutas entre centros del día
        for (let j = 0; j < centers.length - 1; j++) {
          const origin = new window.google.maps.LatLng(
            centers[j].lat,
            centers[j].lng
          );
          const destination = new window.google.maps.LatLng(
            centers[j + 1].lat,
            centers[j + 1].lng
          );

          const result = await this.getRouteData(
            directionsService,
            origin,
            destination
          );
          if (result) {
            centers[j].distanciaAlSiguiente = result.distance.value;
            centers[j].tiempoAlSiguiente = result.duration.value;
            // Aquí asignas el siguiente centro
            centers[j].siguiente = centers[j + 1];
          }
        }
      }
    }

    // Recalcular tiempoTotalDia real (en minutos) ahora que tenemos todos los tiempos
    for (let i = 0; i < routePlan.length; i++) {
      const day = routePlan[i];

      const limpiezaSegundos =
        day.centers.filter((c) => c.type === "center").length *
        this.tiempoLimpiezaCentro *
        3600;

      const conduccionSegundos = day.centers.reduce(
        (sum, c) => sum + (c.tiempoAlSiguiente || 0),
        0
      );

      const desdeInicio = day.travelTimeToFirstCenter || 0;

      const totalSegundos = limpiezaSegundos + conduccionSegundos + desdeInicio;

      day.tiempoTotalDia = Math.round(totalSegundos / 60); // minutos
    }

    return routePlan;
  }

  async getRouteData(
    service: any,
    origin: any,
    destination: any
  ): Promise<{ distance: any; duration: any } | null> {
    return new Promise((resolve) => {
      service.route(
        {
          origin,
          destination,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result: any, status: string) => {
          if (
            status === "OK" &&
            result.routes &&
            result.routes[0] &&
            result.routes[0].legs &&
            result.routes[0].legs[0]
          ) {
            resolve(result.routes[0].legs[0]);
          } else {
            resolve(null);
          }
        }
      );
    });
  }
  async findHotelNearby(lat: number, lng: number): Promise<Hotel> {
    return new Promise((resolve, reject) => {
      if (!window.google || !window.google.maps) {
        reject(new Error("Google Maps API no disponible"));
        return;
      }

      const mapRef = this.$refs.map as Vue & { $mapObject: any };
      if (!mapRef || !mapRef.$mapObject) {
        reject(new Error("Referencia al mapa no disponible"));
        return;
      }

      const service = new window.google.maps.places.PlacesService(
        mapRef.$mapObject
      );

      const request = {
        location: new window.google.maps.LatLng(lat, lng),
        radius: 5000, // Radio de búsqueda en metros
        type: "lodging", // Tipo de lugar: hoteles, hostales, etc.
      };

      service.nearbySearch(request, (results: any[], status: string) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          results.length > 0
        ) {
          // Seleccionar el primer resultado como hotel recomendado
          const hotel = results[0];
          resolve({
            name: hotel.name,
            address: hotel.vicinity,
            price: hotel.price_level || "N/A", // Nivel de precio (si está disponible)
            mapUrl: `https://www.google.com/maps/place/?q=place_id:${hotel.place_id}`,
          });
        } else {
          reject(new Error("No se encontraron hoteles cercanos"));
        }
      });
    });
  }

  async geocodePosition(lat: number, lng: number): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!window.google || !window.google.maps) {
        console.error("Google Maps API no está disponible");
        resolve(`${lat}, ${lng}`);
        return;
      }

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        { location: { lat, lng } },
        (results: any[], status: string) => {
          if (status === "OK" && results[0]) {
            resolve(results[0].formatted_address);
          } else {
            console.error("Geocoder falló:", status);
            resolve(`${lat}, ${lng}`);
          }
        }
      );
    });
  }

}
